import React from "react";

interface FlashIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const FlashIcon: React.FC<FlashIconProps> = ({
  size = 18,
  color = 'white',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M4.56745 9.96001H6.88495V15.36C6.88495 16.62 7.56745 16.875 8.39995 15.93L14.0775 9.48001C14.775 8.69251 14.4825 8.04001 13.425 8.04001H11.1075V2.64001C11.1075 1.38001 10.425 1.12501 9.59245 2.07001L3.91495 8.52001C3.22495 9.31501 3.51745 9.96001 4.56745 9.96001Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FlashIcon;
